/* eslint-disable import/no-unresolved, import/extensions */
import Location from '@nmx/utils/dist/utilities/frontend/location';
import registerComponent from './register_component';

import { navScript } from './helpers/nav.header';

// Grab UTM codes from the url and store them in the session so they can be utilized later for tracking purposes
import './session/utm';

// TODO: so much of this is junk. Will start with markup/styles first, then will come back to address JS/React
import NMXSearch from '../../components/page/Header/components/Search';
import NMLoginButton from './components/nm_login_button.component';
import NMExpandableToast from '../../components/modules/ExpandableToast';
import InformationalBanner from '../../components/modules/InformationalBanner';
import StickyBanner from '../../components/modules/StickyBanner';
import isLeadExternalEndpoint from '../../utils/isLeadExternalEndpoint';

// https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid/2117523#2117523
// eslint-disable-next-line no-bitwise
const getGuid = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));

navScript();

const preClientId = getGuid();
sessionStorage.setItem('pre-client-id', preClientId);
window.adobeDataLayer = window.adobeDataLayer || [];
window.adobeDataLayer.push({
  'user-details': { ids: { 'pre-client-id': preClientId } },
  page: { 'load-path': window.location.pathname.replace(/\/$/, '').toLowerCase() },
});
// Generate FB event ID to be sent along with FB conversion pixel events
const fbEventId = getGuid();
sessionStorage.setItem('fb-event-id', fbEventId);

XMLHttpRequest.prototype.open = (function (open) {
  return function openWithHeaders(...args) {
    const [, url] = args;
    open.apply(this, args);
    if (url.indexOf('/nmx-api-proxy/nmx/') > 0) {
      this.setRequestHeader('X-Pre-Client-Id', preClientId);
    }
    if (isLeadExternalEndpoint(url)) {
      this.setRequestHeader('X-Fb-Event-Id', fbEventId);
      this.setRequestHeader('X-Prelead-Contact-Reference-Id', sessionStorage.getItem('prelead-contact-reference-id'));
    }
  };
}(XMLHttpRequest.prototype.open));

const preleadContactReferenceId = Location.getQueryParam('preleadContactReferenceId');
if (preleadContactReferenceId) {
  sessionStorage.setItem('prelead-contact-reference-id', preleadContactReferenceId);
}

registerComponent('nmx-search', NMXSearch, true);
registerComponent('nm-login-button', NMLoginButton);
registerComponent('nm-expandable-toast', NMExpandableToast);
registerComponent('nm-informational-banner', InformationalBanner, true);
registerComponent('nm-sticky-banner', StickyBanner, true);
